import { ListFlexibleScheduledReportsResponse } from '@flexible-reports/store/api/reports/api-types';
import { FlexibleReport, ScheduledReport } from '@flexible-reports/store/api/reports/types';

// TODO: Update this once api supports returning ScheduledReport with reportPeriod. https://sim.amazon.com/issues/RCMRX-11140
const transformReportPeriod = (scheduledReport: ScheduledReport | any) => {
  return { datePeriod: scheduledReport.period?.datePeriod, preset: scheduledReport.period?.reportConfigurationPresetPeriod?.preset };
};

export const transformListFlexibleScheduledReportsResponse = (response: ListFlexibleScheduledReportsResponse): FlexibleReport[] => {
  return response.scheduledReports.map(scheduledReport => {
    return {
      id: scheduledReport.reportConfigurationId,
      reportId: scheduledReport.scheduledReportId,
      status: scheduledReport.status,
      failureCode: scheduledReport.failureCode,
      lastRun: scheduledReport.scheduledDateTime,
      createdAt: scheduledReport.creationDateTime,
      reportPeriod: transformReportPeriod(scheduledReport),
      recipients: scheduledReport.deliverySettings.email
    };
  });
};
